import { Attribute, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { SnackbarService } from '../../../services/snackbar.service';
import {
  FacturaEstadoDTO,
  FacturaPoseedorControllerService,
  FacturaDTO,
  FacturaPoseedorEstadosControllerService,
  FacturaPoseedorFilterDTO,
  PageDTOFacturaDTO,
  PoseedorControllerService,
  PoseedorFilterDTO,
  DiccionarioElementoDTO,
  DiccionarioControllerService,
} from 'api-rest';
import { HoldersInvoiceNewDocumentDialogComponent } from '../holders-invoice-document-dialog/holders-invoice-document-dialog.component';
import { HoldersInvoiceRejectDialogComponent } from '../holders-invoice-reject-dialog/holders-invoice-reject-dialog.component';
import { HoldersSelfInvoicesCancelRevisionDialogComponent } from '../holders-self-invoices-cancel-revision-dialog/holders-self-invoices-cancel-revision-dialog.component';
import { HoldersInvoiceAccountingDialogComponent } from '../holders-invoice-accounting-dialog/holders-invoice-accounting-dialog.component';
import { HoldersSelfInvoicesDialogComponent } from '../holders-self-invoices-dialog/holders-self-invoices-dialog.component';
import { DocumentService } from '../../../services/document.service';
import moment from 'moment';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { DatePipe } from '@angular/common';
import { FormatCurrencyPipe } from '../../../share/components/pipe/FormatCurrency.pipe';

@Component({
  selector: 'app-holders-self-invoices-search',
  templateUrl: './holders-self-invoices-search.component.html',
  styleUrls: ['./holders-self-invoices-search.component.scss'],
})
export class HoldersSelfInvoicesSearchComponent implements OnInit {
  pageNumber: number = 0;
  pageSize: number = 25;
  recordsTotal: number = 0;

  itemsPerPageOptions: number[] = [25, 50, 75, 100];
  selectedItemsPerPage: number = 25;
  flagSearch: boolean = false;
  totalElements: number = 0;
  totalSearch: number = 0;
  mostrarFiltros: boolean = true;

  poseedorArray: any[] = [];
  estadoArray: any[] = [];

  headArray: any = [
    {
      Head: 'ID. Poseedor',
      FieldName: 'poseedor',
      Attribute: 'id',
    },
    {
      Head: 'Poseedor',
      FieldName: 'poseedor',
      Attribute: 'razonSocial',
    },
    {
      Head: 'Documento',
      FieldName: 'poseedor',
      Attribute: 'codigoDocumento',
    },
    {
      Head: 'NIMA del poseedor',
      FieldName: 'poseedor',
      Attribute: 'nima',
    },
    {
      Head: 'Número de prefactura',
      FieldName: 'id',
      renderValue: (item: FacturaDTO) =>
        item.fechaAutofactura !== null ? item.id : '',
    },
    {
      Head: 'Fecha de prefactura',
      FieldName: 'fechaMAutofactura',
      OrderValue: (item: any) => {
        if (item.fechaAutofactura) {
          return new Date(item.fechaAutofactura);
        }
        return null;
      },
    },
    {
      Head: 'Número factura poseedor ',
      FieldName: 'numeroFactura',
    },
    {
      Head: 'Fecha factura',
      FieldName: 'fechaMFactura',
      OrderValue: (item: any) => {
        if (item.fechaFactura) {
          return new Date(item.fechaFactura);
        }
        return null;
      },
    },
    {
      Head: 'Estado ',
      FieldName: 'estado',
      renderValue: (item: FacturaDTO) =>
        item.estado?.descripcion
    },
    ...((this.canViewRegistrada())
      ? [
        {
          Head: 'Registrada',
          FieldName: 'registrada',
          renderValue: (item: any) =>
            item.registrada ? 'Sí' : 'No',
        },
      ]
      : []),

    {
      Head: 'Número de factura UIPATH',
      FieldName: 'numeroFacturaUipath',
    },
    {
      Head: 'Fecha de factura UIPATH',
      FieldName: 'fechaMFacturaUipath',
      OrderValue: (item: any) => {
        if (item.fechaFacturaUipath) {
          return new Date(item.fechaFacturaUipath);
        }
        return null;
      },
    },
    {
      Head: 'CIF Poseedor',
      FieldName: 'cifPoseedorUipath',
    },
    {
      Head: 'Base imponible / Importe',
      FieldName: 'baseImponibleUipath',
      renderValue: (item: any) => this.formatCurrencyPipe.transform(item.baseImponibleUipath),
      OrderValue: (item: any) => {
        if (item.baseImponibleUipath) {
          return new Date(item.baseImponibleUipath);
        }
        return null;
      },
    },
    {
      Head: 'Tipo de IVA',
      FieldName: 'tipoIVAUipath',
      renderValue: (item: any) => this.formatCurrencyPipe.transform(item.tipoIVAUipath),
      OrderValue: (item: any) => {
        if (item.tipoIVAUipath) {
          return new Date(item.tipoIVAUipath);
        }
        return null;
      },
    },
    {
      Head: 'Importe de IVA',
      FieldName: 'importeIVAUipath',
      renderValue: (item: any) => this.formatCurrencyPipe.transform(item.importeIVAUipath),
      OrderValue: (item: any) => {
        if (item.importeIVAUipath) {
          return new Date(item.importeIVAUipath);
        }
        return null;
      },
    },
    {
      Head: 'Total factura',
      FieldName: 'totalFacturaUipath',
      renderValue: (item: any) => this.formatCurrencyPipe.transform(item.totalFacturaUipath),
      OrderValue: (item: any) => {
        if (item.totalFacturaUipath) {
          return new Date(item.totalFacturaUipath);
        }
        return null;
      },
    },
    {
      Head: 'IBAN',
      FieldName: 'ibanUipath',
    },
    {
      Head: 'SWITF',
      FieldName: 'swiftUipath',
    },
    {
      Head: 'Acciones',
      FieldName: 'actions',
      buttons: [
        {
          nameButton: 'view',
          icon: 'open_in_new',
          toolTip: 'Detalle ',
          show: {
            params: 'canAccessView',
            accion: 'view',
          },
        },
        {
          nameButton: 'delete',
          icon: 'delete',
          toolTip: 'Eliminar registro',
          show: { params: 'canAccessDelete' },
        },
        {
          nameButton: 'add_invoice',
          icon: 'upload_file',
          toolTip: 'Adjuntar factura',
          show: { params: 'canAccessUpInvoice' },
        },
        {
          nameButton: 'menu',
          array: [
            {
              nameButton: 'donwload_invoice',
              name: 'Descargar factura',
              show: { params: 'canAccessDonwloadInvoice' },
            },
            {
              nameButton: 'donwload_self_invoice',
              name: 'Descargar prefactura',
              show: { params: 'canAccessDonwloadSelfInvoice' },
            },
            {
              nameButton: 'accept_invoice',
              name: 'Aceptar factura',
              show: { params: 'canAccessAcceptInvoice' },
            },
            {
              nameButton: 'donwload_pre_invoice-detail',
              name: 'Descargar detalle prefacturación',
              show: { params: 'canAccessDonwloadSelfInvoice' },
            },
            {
              nameButton: 'registrate',
              name: 'Registrar',
              show: { params: 'canAccessRegistrate' },
            },
            {
              nameButton: 'reject_invoice',
              name: 'Rechazar',
              show: { params: 'canRejectInvoice' },
            },
            {
              nameButton: 'accept_invoice_revision',
              name: 'Aceptar',
              show: { params: 'canAccessAcceptInvoiceRevision' },
            },
            {
              nameButton: 'reject_invoice_revision',
              name: 'Rechazar',
              show: { params: 'canRejectInvoiceRevision' },
            },
          ],
        },
      ],
      permanent: true,
    },
  ];
  gridArray: any[] = [];

  searchForm: FormGroup;
orden: DiccionarioElementoDTO[] = [];
  constructor(
    @Inject('environment') private environment: any,
    @Inject('EmpusaAuthenticationService')
    public authService: EmpusaAuthenticationService | any,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private facturaPoseedorControllerService: FacturaPoseedorControllerService,
    private facturaPoseedorEstadosControllerService: FacturaPoseedorEstadosControllerService,
    private poseedorControllerService: PoseedorControllerService,
    private downloadService: DownloadService,
    private documentService: DocumentService,
    private snackBarSrv: SnackbarService,
    private datePipe: DatePipe,
    private formatCurrencyPipe: FormatCurrencyPipe,
    private diccionarioControllerService: DiccionarioControllerService
  ) {
    this.searchForm = this.formBuilder.group({
      poseedor: [{ value: null, disabled: false }],
      idposeedor: [{ value: null, disabled: false }, [Validators.pattern('^[0-9;]+$')]],
      codigo_documento: [{ value: null, disabled: false }],
      razon_social: [{ value: null, disabled: false }],
      nima_poseedor: [{ value: null, disabled: false }],
      numero_autoFactura: [{ value: null, disabled: false }, [Validators.pattern('^[0-9]+$'), Validators.maxLength(10)]],
      fecha_autoFactura: [{ value: null, disabled: false }],
      numero_facturaPoseedor: [{ value: null, disabled: false }, [Validators.maxLength(20)]],
      fecha_facturaPoseedor: [{ value: null, disabled: false }],
      estado: [{ value: null, disabled: false }],
      registrada: [{ value: null, disabled: false }],
      abonoS: [{ value: false, disabled: false }],
      abonoN: [{ value: false, disabled: false }],
                  orden: [{ value: null, disabled: false }],
      tipoOrden: [{ value: null, disabled: false }],
    });
  }

  ngOnInit() {
    this.comboEstados();
    this.getPoseedores();
    this.comboOrden();
  }

  checked(event: any) { }

  renderPage(event: number) {
    this.pageNumber = event;
    if (this.flagSearch) {
      this.searchData();
    }
  }

  exportarExcel() {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.facturaPoseedorControllerService
      .exportCSV4(backendFilter, 'response')
      .subscribe((res) => {
        this.downloadService.exportModal();
        // const filename = this.downloadService.getFileName(
        //   res.headers,
        //   'Exportacion_Factura_Poseedor.csv'
        // );
        // this.downloadService.downloadCSV(res.body!, filename!);
      });
  }

  clearSearcher() {
    this.searchForm.reset();
    this.flagSearch = false;
    this.gridArray = [];
  }

  toggleFiltros(): void {
    this.mostrarFiltros = !this.mostrarFiltros;
  }

  quitarFiltro(filtro: { label: string; campo: string; value?: any }): void {
    if (filtro.campo === 'abono') {
      this.searchForm.get('abonoS')?.setValue(false);
      this.searchForm.get('abonoN')?.setValue(false);
    } else if (filtro.value !== undefined) {
      const current = this.searchForm.get(filtro.campo)?.value as any[];
      if (Array.isArray(current)) {
        const updated = current.filter((v) => {
          const currentId = v?.id ?? v;
          const removeId = filtro.value?.id ?? filtro.value;
          return currentId !== removeId;
        });
        this.searchForm.get(filtro.campo)?.setValue(updated.length ? updated : null);
      }
    } else {
      this.searchForm.get(filtro.campo)?.reset();
    }

    this.pageNumber = 1;
    //this.searchData();
  }

  get filtrosAplicados(): { label: string; campo: string; value?: any }[] {
    const filtros: { label: string; campo: string; value?: any }[] = [];

    const poseedores = this.searchForm.get('poseedor')?.value as any[];
    if (poseedores?.length) {
      poseedores.forEach((poseedorId: any) => {
        const poseedor = this.poseedorArray.find((p: any) => p.id === poseedorId);
        const label = poseedor
          ? `${poseedor.tipoDocumento} ${poseedor.codigoDocumento} - ${poseedor.denominacionCentro}`
          : String(poseedorId);
        filtros.push({ label: ` ${label}`, campo: 'poseedor', value: poseedorId });
      });
    }

    const idPoseedor = this.searchForm.get('idposeedor')?.value;
    if (idPoseedor) {
      filtros.push({ label: ` ${idPoseedor}`, campo: 'idposeedor' });
    }

    const codigoDocumento = this.searchForm.get('codigo_documento')?.value;
    if (codigoDocumento) {
      filtros.push({ label: ` ${codigoDocumento}`, campo: 'codigo_documento' });
    }

    const razonSocial = this.searchForm.get('razon_social')?.value;
    if (razonSocial) {
      filtros.push({ label: ` ${razonSocial}`, campo: 'razon_social' });
    }

    const nima = this.searchForm.get('nima_poseedor')?.value;
    if (nima) {
      filtros.push({ label: ` ${nima}`, campo: 'nima_poseedor' });
    }

    const numeroPrefactura = this.searchForm.get('numero_autoFactura')?.value;
    if (numeroPrefactura) {
      filtros.push({ label: ` ${numeroPrefactura}`, campo: 'numero_autoFactura' });
    }

    const fechaPrefactura = this.searchForm.get('fecha_autoFactura')?.value;
    if (fechaPrefactura) {
      const label = this.datePipe.transform(fechaPrefactura, 'dd/MM/yyyy') ?? fechaPrefactura;
      filtros.push({ label: ` ${label}`, campo: 'fecha_autoFactura' });
    }

    const numeroFactura = this.searchForm.get('numero_facturaPoseedor')?.value;
    if (numeroFactura) {
      filtros.push({ label: ` ${numeroFactura}`, campo: 'numero_facturaPoseedor' });
    }

    const fechaFactura = this.searchForm.get('fecha_facturaPoseedor')?.value;
    if (fechaFactura) {
      const label = this.datePipe.transform(fechaFactura, 'dd/MM/yyyy') ?? fechaFactura;
      filtros.push({ label: ` ${label}`, campo: 'fecha_facturaPoseedor' });
    }

    const estados = this.searchForm.get('estado')?.value as any[];
    if (estados?.length) {
      estados.forEach((estado: any) => {
        filtros.push({
          label: ` ${estado?.descripcion ?? String(estado?.id ?? estado)}`,
          campo: 'estado',
          value: estado,
        });
      });
    }

    const registrada = this.searchForm.get('registrada')?.value;
    if (registrada) {
      filtros.push({ label: ' Sí', campo: 'registrada' });
    }

    const abonoS = this.searchForm.get('abonoS')?.value;
    const abonoN = this.searchForm.get('abonoN')?.value;
    if (abonoS || abonoN) {
      filtros.push({ label: ` ${abonoS ? 'Sí' : 'No'}`, campo: 'abono' });
    }

const ordenes = this.searchForm.get('orden')?.value;
    if (Array.isArray(ordenes) && ordenes.length) {
      ordenes.forEach((ordenCodigo: any) => {
        filtros.push({
          label: `Orden: ${String(ordenCodigo)}`,
          campo: 'orden',
          value: ordenCodigo,
        });
      });
    } else if (ordenes) {
      filtros.push({ label: `Órdenes: ${String(ordenes)}`, campo: 'orden' });
    }

    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    if (tipoOrden) {
      const label =
        tipoOrden === 'ASC'
          ? 'Ascendente'
          : tipoOrden === 'DESC'
          ? 'Descendente'
          : String(tipoOrden);
      filtros.push({ label: `Tipo orden: ${label}`, campo: 'tipoOrden' });
    }

    return filtros;
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.searchForm.controls[controlName].hasError(errorName) &&
      this.searchForm.controls[controlName].touched
    );
  }

  getPoseedores() {
    if (this.authService.user?.roleEntities?.length > 0) {
      const poseedorIds = this.authService.user?.roleEntities
        .filter((poseedorRol: any) => poseedorRol.type === 'POSEEDOR')
        .flatMap((poseedorRol: any) => {
          if (poseedorRol.entity == null || poseedorRol.entity == undefined) {
            return [];
          } else if (Array.isArray(poseedorRol.entity)) {
            return poseedorRol.entity;
          } else {
            return [poseedorRol.entity];
          }
        });
      const filter: PoseedorFilterDTO = {
        id: poseedorIds,
      };
      this.spinnerSrv.loadingShow();
      this.poseedorControllerService
        .findAll5(filter, { page: 0, size: 100 })
        .subscribe({
          next: (response: any) => {
            this.poseedorArray = response?.datos;
            this.spinnerSrv.loadingHide();
          },
          error: (err) => {
            console.log(err);
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }

  private getBackendFilter() {
    const {
      poseedor,
      idposeedor,
      codigo_documento,
      razon_social,
      nima_poseedor,
      numero_autoFactura,
      fecha_autoFactura,
      numero_facturaPoseedor,
      fecha_facturaPoseedor,
      estado
    } = this.searchForm.controls;

    const formatDate = (date: any) => {
      if (date && date.value) {
        return moment(new Date(date.value)).format('DD/MM/YYYY');
      }
      return undefined;
    };

    let registrada;
    if (this.searchForm.get('registrada')?.value) {
      registrada = this.searchForm.get('registrada')?.value
    }
    let abono;
    if (this.searchForm.get('abonoS')?.value === true) {
      abono = 'SI';
    } else if (this.searchForm.get('abonoN')?.value === true) {
      abono = 'NO';
    }
    const selectEstadoA = this.searchForm.get('estado')?.value;
    let selectEstadosIdA: any[] = [];
    if (selectEstadoA !== undefined && selectEstadoA !== null) {
      selectEstadosIdA = selectEstadoA.map((objeto: any) =>
        objeto.id !== undefined ? objeto.id : objeto
      );
    }
    const backendFilter: FacturaPoseedorFilterDTO = {
      poseedor: {
        id:
          idposeedor.value != null
            ? idposeedor.value
            : poseedor.value != null && poseedor.value != undefined && poseedor.value.length > 0
              ? poseedor.value
              : [],
        codigoDocumento: codigo_documento?.value,
        razonSocial:
          razon_social?.value != null ? razon_social?.value : undefined,
        nima: nima_poseedor?.value,
      },
      numeroAutofactura: numero_autoFactura?.value,
      fechaAutofactura: formatDate(fecha_autoFactura),
      numeroFactura: numero_facturaPoseedor?.value,
      fechaFactura: formatDate(fecha_facturaPoseedor),
      estado: { id: selectEstadosIdA },
      origen: 'POSEEDORES',
      registrada: registrada,
      abono: abono,
    };

    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;
    const orden = this.searchForm.get('orden')?.value;
    const tipoOrden = this.searchForm.get('tipoOrden')?.value;
    return { backendFilter, page, size: this.pageSize , orden, tipoOrden};
  }

  searchData(initPage: boolean = false) {
    if (initPage) {
      this.pageNumber = 0;
    }
    if (this.searchForm.invalid) {
      this.searchForm.markAllAsTouched();
      return;
    }
    const { backendFilter, page, size, orden, tipoOrden} = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.facturaPoseedorControllerService
      .findAll10(backendFilter, {
        page: page,
        size: size,
        sort: ['id,desc'],
      },
        orden,
        tipoOrden)
      .subscribe({
        next: (data: PageDTOFacturaDTO) => {
          if (data) {
            this.spinnerSrv.loadingHide();
            this.flagSearch = data.datos?.length != 0 ? true : false;
            this.gridArray = this.canAccessAll(data.datos) ?? [];
            this.recordsTotal = data.paginacion?.totalElements ?? 0;
            this.totalSearch = this.gridArray.length;
          }
        },
        error: (error: any) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  onItemsPerPageChange() {
    this.pageSize = this.selectedItemsPerPage;
    this.searchData();
  }

  action(element: any) {
    if (element.nameButton == 'view') {
      this.openModalDetail(element);
    } else if (element.nameButton == 'delete') {
      this.confirmacionEliminar(element);
    } else if (element.nameButton == 'add_invoice') {
      this.openModalUploadInvoice(element);
    } else if (element.nameButton == 'donwload_invoice') {
      this.descargar(element.documento);
    } else if (element.nameButton == 'donwload_self_invoice') {
      this.descargar(element.documentoAutofactura);
    } else if (element.nameButton == 'accept_invoice') {
      this.confirmacionCambioEstado(element.id, 3);
    } else if (element.nameButton == 'donwload_pre_invoice-detail') {
      this.descargarDetallePrefacturacion(element);
    } else if (element.nameButton == 'reject_invoice') {
      this.openModalMotivoRechazo(element);
    } else if (element.nameButton == 'registrate') {
      this.registrarFactura(element);
    } else if (element.nameButton == 'accept_invoice_revision') {
      this.aceptarFacturaRevision(element);
    } else if (element.nameButton == 'reject_invoice_revision') {
      this.cancelarFacturaRevision(element);
    }
  }

  confirmacionEliminar(element?: any): void {
    Swal.fire({
      text: `¿Desea eliminar la prefactura?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.eliminarInvoices(element);
      }
    });
  }

  eliminarInvoices(element?: any) {
    if (element?.id) {
      this.spinnerSrv.loadingShow();
      this.facturaPoseedorControllerService.deleteById5(element.id).subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            `El registro de factura se ha eliminado correctamente`,
            'success'
          );
          this.gridArray = this.gridArray.filter(
            (objeto) => objeto.id !== element.id
          );
          this.flagSearch = this.gridArray.length != 0 ? true : false;
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
        },
      });
    }
  }

  comboEstados() {
    this.facturaPoseedorEstadosControllerService.findAll11().subscribe({
      next: (data: Array<FacturaEstadoDTO>) => {
        this.estadoArray = data!;
      },
      error: () => { },
    });
  }
  comboOrden() {
    this.diccionarioControllerService.listarElementos(['ORDEN_POSEEDORES_PREFACTURAS_FACTURAS_BUSQUEDA']).subscribe({
      next: (data: any) => {

        this.orden = data['ORDEN_POSEEDORES_PREFACTURAS_FACTURAS_BUSQUEDA']!;
      },
      error: () => { },
    });
  }
  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.searchForm.controls[controlName]?.touched ||
        this.searchForm.controls[controlName]?.dirty) &&
      this.searchForm.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  showClearButton(formName: string): boolean {
    return this.searchForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.searchForm.get(formName)?.setValue(null);
  }

  openModalUploadInvoice(element?: any): void {
    const dialogRef = this.dialog.open(
      HoldersInvoiceNewDocumentDialogComponent,
      {
        width: '650px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          itemOpen: element,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

  openModalDetail(element?: any): void {
    const dialogRef = this.dialog.open(
      HoldersSelfInvoicesDialogComponent,
      {
        width: '950px',
        maxWidth: '98%',
        maxHeight: '95vh',
        data: element,
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

  descargar(documento: any) {
    this.spinnerSrv.loadingShow();
    this.documentService.descargarDocumento(documento.id).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Se ha descargado el documento correctamente',
          'success'
        );
        this.downloadService.downloadBlob(response, documento.nombre);
      },
      error: () => {
        this.spinnerSrv.loadingHide();
      },
    });
  }

  descargarDetallePrefacturacion(documento: any) {
    //this.spinnerSrv.loadingShow();
    this.facturaPoseedorControllerService.prefacturaDetalle(documento.id, 'response')
      .subscribe((res: any) => {
        const filename = this.downloadService.getFileName(
          res.headers,
          'Prefacturación.xlsx'
        );
        this.downloadService.downloadBlob(res.body!, filename!);
      });
  }

  registrarFactura(item: any) {
    this.spinnerSrv.loadingShow();
    this.facturaPoseedorControllerService.registrarFactura(item.id)
      .subscribe({
        next: (res: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            `La factura se ha registrado correctamente`,
            'success'
          );
          this.searchData();
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  confirmacionCambioEstado(id?: any, estadoId?: any): void {
    Swal.fire({
      text: `¿Desea cambiar el estado del registro por Aceptada por Envalora?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.actualizarEstado(id, estadoId);
      }
    });
  }

  actualizarEstado(id?: any, estadoId?: any) {
    if (id && estadoId) {
      this.spinnerSrv.loadingShow();
      this.facturaPoseedorControllerService
        .actualizarEstado(id, estadoId)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              `El registro de factura se ha actualizado correctamente`,
              'success'
            );
            this.searchData();
          },
          error: (err: { message: any }) => {
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  canAccessExport(): boolean {
    return this.authService.can('poseedores-facturas', 'update-exportar');
  }

  canViewRegistrada(): boolean {
    return this.authService.can('poseedores-facturas', 'view-registrada');
  }

  canAccessEnvalora(): boolean {
    return this.canViewResource('PO-ENV-GEST') || this.canViewResource('PO-ENV-CONS');
  }

  canAccessInformeContabilizacion(): boolean {
    return this.authService.can('poseedores-facturas', 'access-informe-contabilizacion');
  }

  canAccessAll(list: any) {
    const resultDelete = this.authService.can('poseedores-facturas', 'delete');
    const resultUpFactura = this.authService.can(
      'poseedores-facturas',
      'update'
    );
    const resultDownloadAutofactura = this.authService.can(
      'poseedores-facturas',
      'download-autofactura'
    );
    const resultDownloadFactura = this.authService.can(
      'poseedores-facturas',
      'download-factura'
    );
    const resultUpdateAccept = this.authService.can(
      'poseedores-facturas',
      'update-accept'
    );

    const resultReject = this.authService.can(
      'poseedores-facturas',
      'reject-factura'
    );

    const isGestorEnvalora = this.canViewResource('PO-ENV-GEST');

    const resultRegistrate = this.authService.can(
      'poseedores-facturas',
      'registrar'
    );

    const resultDetail = this.authService.can(
      'poseedores-facturas-detalle',
      'access-all'
    );

    const listPermission = list.map((objeto: any) => {
      const estado1 = objeto.estado && objeto.estado.id === 1; //Pdte Factura
      const estado2 = objeto.estado && objeto.estado.id === 2; //Facturada
      const estado3 = objeto.estado && objeto.estado.id === 3; //Aceptada
      const estado4 = objeto.estado && objeto.estado.id === 4; //Rechazada
      const estado5 = objeto.estado && objeto.estado.id === 5; //Pdte Revisión

      let formattedDate =
        objeto.fechaFactura != null
          ? this.datePipe.transform(objeto.fechaFactura, 'dd/MM/yyyy')
          : null;
      objeto.fechaMFactura = formattedDate;

      let formattedDateM =
        objeto.fechaAutofactura != null
          ? this.datePipe.transform(objeto.fechaAutofactura, 'dd/MM/yyyy')
          : null;
      objeto.fechaMAutofactura = formattedDateM;
      let fechaMFacturaUipath =
        objeto.fechaAutofactura != null
          ? this.datePipe.transform(objeto.fechaFacturaUipath, 'dd/MM/yyyy')
          : null;
      objeto.fechaMFacturaUipath = fechaMFacturaUipath;
      return {
        ...objeto,
        canAccessView: resultDetail,
        canAccessDelete: resultDelete && estado1,
        canAccessUpInvoice: resultUpFactura && (estado1 || estado4),
        canAccessDonwloadInvoice: resultDownloadFactura && (estado2 || estado3 || estado4 || estado5),
        canAccessDonwloadSelfInvoice: resultDownloadAutofactura,
        canAccessAcceptInvoice: (resultUpdateAccept && estado2) || (isGestorEnvalora && estado4),
        canRejectInvoice: resultReject && estado2,
        canAccessRegistrate: resultRegistrate && estado3 && !objeto.registrada,
        canRejectInvoiceRevision: resultReject && estado5,
        canAccessAcceptInvoiceRevision: (resultUpdateAccept && estado5) || (isGestorEnvalora && estado5),
      };
    });

    return listPermission;
  }
  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  onlyNumberCommaKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9;]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
  onAbonoChange(tipo: 'S' | 'N', checked: boolean) {
    if (!checked) {
      return;
    }
    if (tipo === 'S') {
      this.searchForm.get('abonoN')?.setValue(false);
    } else {
      this.searchForm.get('abonoS')?.setValue(false);
    }
  }
  openModalMotivoRechazo(item: any) {
    const dialogRef = this.dialog.open(
      HoldersInvoiceRejectDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: item,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

  cancelarFacturaRevision(element: any) {
    const dialogRef = this.dialog.open(
      HoldersSelfInvoicesCancelRevisionDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: element,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

  aceptarFacturaRevision(element: any) {
    this.spinnerSrv.loadingShow();
    this.facturaPoseedorControllerService.aceptarFactura(element.id).subscribe({
      next: (res) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Factura aceptada correctamente',
          'success'
        );
        this.searchData();
      },
      error: (err) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Error al aceptar la factura',
          'error'
        );
      }
    });
  }

  openModalAccounting(element?: any): void {
    const dialogRef = this.dialog.open(
      HoldersInvoiceAccountingDialogComponent,
      {
        width: '650px',
        maxWidth: '95%',
        maxHeight: '95vh',
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.searchData();
      }
    });
  }

}
